module.exports = __webpack_public_path__ + "media/images/xpass/markers/inactive/kinrgy-a238a354cffaf74db4b67f97156ec784.png";